// frontend/src/pages/ForgotPassword.jsx
import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import Swal from "sweetalert2";
import { Mail, ArrowLeft, Send } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/password/forgot`, { email });
      
      setSent(true);
      Swal.fire({
        icon: "success",
        title: "E-mail enviado!",
        text: "Verifique sua caixa de entrada para redefinir sua senha.",
        confirmButtonColor: "#449779",
        timer: 3000,
        customClass: {
          popup: "text-sm rounded-xl",
        },
      });
    } catch (error) {
      const message = error.response?.data?.message || "Erro ao enviar e-mail. Tente novamente.";
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: message,
        confirmButtonColor: "#449779",
        customClass: {
          popup: "text-sm rounded-xl",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="text-center mb-8">
          {/* 🔥 REEMPLAZADO: "BV" por logo brecho.png */}
          <div className="flex justify-center mb-4">
            <img
              src={`${process.env.PUBLIC_URL}/brecho.png`}
              alt="Brechó Vizinho"
              className="w-16 h-16 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Verifique seu e-mail</h1>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
          <Mail className="w-12 h-12 text-[#449779] mx-auto mb-4" />
          <p className="text-gray-600 mb-2">
            Enviamos um link de redefinição de senha para:
          </p>
          <p className="font-semibold text-gray-800 mb-4 break-all">{email}</p>
          <p className="text-sm text-gray-500 mb-6">
            Clique no link do e-mail para criar uma nova senha.<br />
            O link é válido por 24 horas.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-[#449779] hover:underline"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar para o login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 py-8">
      {/* Logo e título */}
      <div className="text-center mb-8">
        {/* 🔥 REEMPLAZADO: "BV" por logo brecho.png */}
        <div className="flex justify-center mb-4">
          <img
            src={`${process.env.PUBLIC_URL}/brecho.png`}
            alt="Brechó Vizinho"
            className="w-16 h-16 object-contain"
          />
        </div>
        <h1 className="text-2xl font-bold text-gray-800">Esqueci minha senha</h1>
        <p className="text-sm text-gray-500 mt-1">
          Digite seu e-mail e enviaremos um link para redefinir sua senha
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            E-mail cadastrado
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#449779] focus:border-transparent"
              required
              disabled={loading}
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#449779] text-white py-3 rounded-xl font-semibold hover:bg-[#2d5f4d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {loading ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              Enviando...
            </div>
          ) : (
            <>
              <Send className="w-5 h-5" />
              Enviar link de redefinição
            </>
          )}
        </button>

        <div className="text-center">
          <Link
            to="/login"
            className="text-sm text-gray-500 hover:text-[#449779] transition-colors inline-flex items-center gap-1"
          >
            <ArrowLeft className="w-3 h-3" />
            Voltar para o login
          </Link>
        </div>
      </form>
    </div>
  );
}